var paragraph_default = {
  "fontElementMap": "Ctm1A",
  "elementSpacing": "irnTT",
  "text": "_6ZNRI irnTT",
  "child": "Xcp8l"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
